// src/routes.js
import Dashboard                from '@pages/Dashboard';
import TrangChu from '@pages/trangChu/TrangChu';
import Profile                  from '@pages/profile/Profile';
import Account                  from '@pages/account/Account';
import AccountAdd               from '@pages/account/AccountAdd';
import AccountEdit              from '@pages/account/AccountEdit';
import EmailConfig              from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd           from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit          from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory             from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory    from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log                      from '@pages/log/Log';
import ApiRoleMapping           from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd        from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit       from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';

import { URI_INTERNAL } from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';

import BoPhan from '@pages/boPhan/BoPhan';
import BoPhanAdd from '@pages/boPhan/BoPhanAdd';
import BoPhanEdit from '@pages/boPhan/BoPhanEdit';

import Team from '@pages/team/Team';
import TeamAdd from '@pages/team/TeamAdd';
import TeamEdit from '@pages/team/TeamEdit';

import NhanVien from '@pages/nhanVien/NhanVien';
import NhanVienAdd from '@pages/nhanVien/NhanVienAdd';
import NhanVienEdit from '@pages/nhanVien/NhanVienEdit';

import HoTro from '@app/pages/hotro/HoTro';
import HoTroAdd from '@app/pages/hotro/HoTroAdd';
import HoTroEdit from '@app/pages/hotro/HoTroEdit';

import YeuCau from '@app/pages/yeucau/YeuCau';
import YeuCauAdd from '@app/pages/yeucau/YeuCauAdd';
import YeuCauEdit from '@app/pages/yeucau/YeuCauEdit';

import Khoa from '@app/pages/danhmuckhoa/DMKhoa';
import KhoaAdd from '@app/pages/danhmuckhoa/DMKhoaAdd';
import KhoaEdit from '@app/pages/danhmuckhoa/DMKhoaEdit';

import QuyTrinh from '@app/pages/quyTrinh/QuyTrinh';
import QuyTrinhAdd from '@app/pages/quyTrinh/QuyTrinhAdd';
import QuyTrinhEdit from '@app/pages/quyTrinh/QuyTrinhEdit';

import Project from '@app/pages/project/Project';
import ProjectAdd from '@app/pages/project/ProjectAdd';
import ProjectEdit from '@app/pages/project/ProjectEdit';
import ProjectDetail from '@app/pages/project/ProjectDetail';
import ProjectStepBoard from '@app/pages/project/ProjectStepBoard';

import LinhVuc from '@app/pages/linhvuc/LinhVuc';
import LinhVucAdd from '@app/pages/linhvuc/LinhVucAdd';
import LinhVucEdit from '@app/pages/linhvuc/LinhVucEdit';

import LoaiYeuCau from '@app/pages/loaiyeucau/LoaiYeuCau';
import LoaiYeuCauAdd from '@app/pages/loaiyeucau/LoaiYeuCauAdd';
import LoaiYeuCauEdit from '@app/pages/loaiyeucau/LoaiYeuCauEdit';

import NhiemVuKhac from '@app/pages/nhiemvukhac/NhiemVuKhac';
import NhiemVuKhacAdd from '@app/pages/nhiemvukhac/NhiemVuKhacAdd';
import NhiemVuKhacEdit from '@app/pages/nhiemvukhac/NhiemVuKhacEdit';

import CongViecKhac from '@app/pages/nhiemvukhac/CongViecKhac';

import NhiemVuCaNhan from '@app/pages/nhiemvucanhan/NhiemVuCaNhan';

import NguoiPhoiHop from '@app/pages/nguoiPhoiHop/NguoiPhoiHop';
import NguoiPhoiHopAdd from '@app/pages/nguoiPhoiHop/NguoiPhoiHopAdd';
import NguoiPhoiHopEdit from '@app/pages/nguoiPhoiHop/NguoiPhoiHopEdit';

import BaoCaoTongQuanTeam from '@app/pages/baocao/BaoCaoTongQuanTeam';
import BaoCaoTongQuanNhanVien from '@app/pages/baocao/BaoCaoTongQuanNhanVien';
import BaoCaoChiTietNhanVien from '@app/pages/baocao/BaoCaoChiTietNhanVien';
import BaoCaoChiTietPhatTrienPhanMem from '@app/pages/baocao/BaoCaoChiTietPhatTrienPhanMem';
import BaoCaoChiTietXuLyYeuCauThanhVien from '@app/pages/baocao/BaoCaoChiTietXuLyYeuCauThanhVien';
import BaoCaoChiTietHoTroThanhVien from '@app/pages/baocao/BaoCaoChiTietHoTroThanhVien';
import BaoCaoChiTietNhiemVuKhac from '@app/pages/baocao/BaoCaoChiTietNhiemVuKhac';
import BaoCaoChiTietNhiemVuKhacThanhVien from '@app/pages/baocao/BaoCaoChiTietNhiemVuKhacThanhVien';

import BaoCaoTongHopNhanVien from '@app/pages/baocao/BaoCaoTongHopNhanVien';

const rawRoutes = [
  // dashboard
  //{
  //  path: "/",
  //  exact: true,
  //  component: Dashboard,
  //  controller: '',
  //  action: '',
  //  label: "Dashboard",
  //  menu: true,
  //  isPublic: false,
  //},
  {
    path: URI_INTERNAL.HOME_PATH,
    exact: true,
    component: TrangChu,
    controller: 'Home',
    action: '',
    label: "Trang chủ",
    menu: true,   
    isPublic: false,
    skipPermission: true,
  },

  /// HoTro
  {
    path: URI_INTERNAL.HOTRO_PATH,
    exact: true,
    component: HoTro,
    controller: 'HoTro',
    action: '',
    label: "Hỗ trợ",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.HOTRO_CREATE_PATH,
    exact: true,
    component: HoTroAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
  path: URI_INTERNAL.HOTRO_EDIT_PATH,
  exact: true,
  component: HoTroEdit,
  isPublic: false,
  controller: '',
  action: '',
  label: "",
  menu: false,
  isPublic: false,
    },

    /// YeuCau
   {
        path: URI_INTERNAL.YEUCAU_PATH,
        exact: true,
        component: YeuCau,
        isPublic: false,
        controller: 'YeuCaus',
        action: '',
        label: "Yêu cầu",
        menu: true,
        isPublic: false,
   },
   {
        path: URI_INTERNAL.YEUCAU_CREATE_PATH,
        exact: true,
        component: YeuCauAdd,
        isPublic: false,
        controller: '',
        action: '',
        label: "",
        menu: false,
        isPublic: false,
   },
   {
        path: URI_INTERNAL.YEUCAU_EDIT_PATH,
        exact: true,
        component: YeuCauEdit,
        isPublic: false,
        controller: '',
        action: '',
        label: "",
        menu: false,
        isPublic: false,
    },
    

    /// Nhiệm vụ khác
    {
        path: URI_INTERNAL.NHIEMVUKHAC_PATH,
        exact: true,
        component: NhiemVuKhac,
        isPublic: false,
        controller: 'NhiemVuKhac',
        action: '',
        label: "Nhiệm vụ khác",
        menu: true,
        isPublic: false,
    },
    {
        path: URI_INTERNAL.NHIEMVUKHAC_CREATE_PATH,
        exact: true,
        component: NhiemVuKhacAdd,
        isPublic: false,
        controller: '',
        action: '',
        label: "",
        menu: false,
        isPublic: false,
    },
    {
        path: URI_INTERNAL.NHIEMVUKHAC_EDIT_PATH,
        exact: true,
        component: NhiemVuKhacEdit,
        isPublic: false,
        controller: '',
        action: '',
        label: "",
        menu: false,
        isPublic: false,
    },
    // Công việc của Nhiệm vụ khác
    {
        path: URI_INTERNAL.NHIEMVUKHAC_CONGVIEC_PATH,
        exact: true,
        component: CongViecKhac,
        isPublic: false,
        controller: '',
        action: '',
        label: "",
        menu: false,
        isPublic: false,
    },

  // profile
  {
    path: "/profile",
    exact: true,
    component: Profile,
    controller: '',
    action: '',
    label: "Thông tin cá nhân",
    menu: false,
    isPublic: false,
  },

  // account
  {
    path: URI_INTERNAL.ACCOUNT_PATH,
    exact: true,
    component: Account,
    controller: 'Account',
    action: '',
    label: "Tài khoản",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_ADD,
    exact: true,
    component: AccountAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
    exact: true,
    component: AccountEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // role
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
    exact: true,
    component: RoleAccount,
    controller: 'Role',
    action: '',
    label: "Quyền",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
    exact: true,
    component: RoleAccountAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
    exact: true,
    component: RoleAccountEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // email config
  {
    path: URI_INTERNAL.EMAILCONFIG_PATH,
    exact: true,
    component: EmailConfig,
    controller: 'EmailConfig',
    action: '',
    label: "Email gửi thông báo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
    exact: true,
    component: EmailConfigAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
    exact: true,
    component: EmailConfigEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // reports
  {
    path: URI_INTERNAL.LOGIN_HISTORY_PATH,
    exact: true,
    component: LoginHistory,
    controller: 'LoginHistory',
    action: '',
    label: "Lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
    exact: true,
    component: StatisticLoginHistory,
    controller: 'StatisticLoginHistory', // để group "Báo cáo" lấy được
    action: '',
    label: "Thống kê lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },

  // api-role-mapping
  {
    path: URI_INTERNAL.APIROLEMAPPING_PATH,
    exact: true,
    component: ApiRoleMapping,
    controller: 'ApiRoleMapping',
    action: '',
    label: "Phân quyền API",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
    exact: true,
    component: ApiRoleMappingAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
    exact: true,
    component: ApiRoleMappingEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // OpeniddictApplication
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
    exact: true,
    component: OpeniddictApplication,
    controller: 'OpeniddictApplication',
    action: '',
    label: "Ứng dụng đăng ký",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
    exact: true,
    component: OpeniddictApplicationAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
    exact: true,
    component: OpeniddictApplicationEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // log
  {
    path: URI_INTERNAL.LOG_PATH,
    exact: true,
    component: Log,
    controller: 'Log',
    action: '',
    label: "Xem log",
    menu: true,
    isPublic: false,
  },

  // Danh mục Bộ phận
  {
    path: URI_INTERNAL.BOPHAN_PATH,
    exact: true,
    component: BoPhan,
    controller: 'BoPhan',
    action: '',
    label: "Bộ phận",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BOPHAN_CREATE_PATH,
    exact: true,
    component: BoPhanAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BOPHAN_EDIT_PATH,
    exact: true,
    component: BoPhanEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // Danh mục Team
  {
    path: URI_INTERNAL.TEAM_PATH,
    exact: true,
    component: Team,
    controller: 'Team',
    action: '',
    label: "Team",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TEAM_CREATE_PATH,
    exact: true,
    component: TeamAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TEAM_EDIT_PATH,
    exact: true,
    component: TeamEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // Danh mục Nhân viên
  {
    path: URI_INTERNAL.NHANVIEN_PATH,
    exact: true,
    component: NhanVien,
    controller: 'NhanVien',
    action: '',
    label: "Nhân viên",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NHANVIEN_CREATE_PATH,
    exact: true,
    component: NhanVienAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NHANVIEN_EDIT_PATH,
    exact: true,
    component: NhanVienEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // Danh mục Khoa
  {
    path: URI_INTERNAL.KHOA_PATH,
    exact: true,
    component: Khoa,
    controller: 'Khoa',
    action: '',
    label: "Khoa",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KHOA_CREATE_PATH,
    exact: true,
    component: KhoaAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KHOA_EDIT_PATH,
    exact: true,
    component: KhoaEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // Danh mục Quy trình
  {
    path: URI_INTERNAL.QUYTRINH_PATH,
    exact: true,
    component: QuyTrinh,
    controller: 'QuyTrinh',
    action: '',
    label: "Quy trình",
    menu: true, // cho hiện trong sidebar
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUYTRINH_CREATE_PATH,
    exact: true,
    component: QuyTrinhAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUYTRINH_EDIT_PATH,
    exact: true,
    component: QuyTrinhEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // Project
  {
    path: URI_INTERNAL.PROJECT_PATH,
    exact: true,
    component: Project,
    controller: 'Project',
    action: '',
    label: "Phát triển dự án",
    menu: true,
    isPublic: false,
  },
   {
    path: URI_INTERNAL.PROJECT_STEP_BOARD_PATH,
    exact: true,
    component: ProjectStepBoard,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_CREATE_PATH,
    exact: true,
    component: ProjectAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_EDIT_PATH,
    exact: true,
    component: ProjectEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_DETAIL_PATH,
    exact: true,
    component: ProjectDetail,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  // Danh mục Lĩnh vực
  {
    path: URI_INTERNAL.LINHVUC_PATH,
    exact: true,
    component: LinhVuc,
    controller: 'LinhVuc',
    action: '',
    label: "Lĩnh vực",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LINHVUC_CREATE_PATH,
    exact: true,
    component: LinhVucAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LINHVUC_EDIT_PATH,
    exact: true,
    component: LinhVucEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },

  {
    path: URI_INTERNAL.LOAIYEUCAU_PATH,
    exact: true,
    component: LoaiYeuCau,
    controller: 'LoaiYeuCau',
    action: '',
    label: 'Loại yêu cầu',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LOAIYEUCAU_CREATE_PATH,
    exact: true,
    component: LoaiYeuCauAdd,
    controller: '',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LOAIYEUCAU_EDIT_PATH,
    exact: true,
    component: LoaiYeuCauEdit,
    controller: '',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
        path: URI_INTERNAL.NHIEMVU_CANHAN_PATH,
        exact: true,
        component: NhiemVuCaNhan,
        controller: 'NhiemVuCaNhan',
        action: '',
        label: "Nhiệm vụ cá nhân",
        menu: true,
        isPublic: false,
    },

  // Danh mục Người phối hợp
  {
    path: URI_INTERNAL.NGUOIPHOIHOP_PATH,
    exact: true,
    component: NguoiPhoiHop,
    controller: 'NguoiPhoiHop',
    action: '',
    label: "Người phối hợp",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGUOIPHOIHOP_CREATE_PATH,
    exact: true,
    component: NguoiPhoiHopAdd,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGUOIPHOIHOP_EDIT_PATH,
    exact: true,
    component: NguoiPhoiHopEdit,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_THONGKE_PATH,
    exact: true,
    component: BaoCaoTongQuanTeam,
    controller: 'BaoCao',           
    action: '',
    label: 'Báo cáo thống kê',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_THONG_HOP_NHAN_VIEN_PATH,
    exact: true,
    component: BaoCaoTongHopNhanVien,
    controller: 'BaoCao',
    action: '',
    label: 'Báo cáo nhân viên',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_TONG_QUAN_NHAN_VIEN_PATH,
    exact: true,
    component: BaoCaoTongQuanNhanVien,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_CHI_TIET_NHAN_VIEN_PATH,
    exact: true,
    component: BaoCaoChiTietNhanVien,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_CHI_TIET_PHAT_TRIEN_PHAN_MEM_PATH,
    exact: true,
    component: BaoCaoChiTietPhatTrienPhanMem,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,       
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_CHI_TIET_XU_LY_YEU_CAU_PATH,
    exact: true,
    component: BaoCaoChiTietXuLyYeuCauThanhVien,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_CHI_TIET_HO_TRO_THANH_VIEN_PATH,
    exact: true,
    component: BaoCaoChiTietHoTroThanhVien,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_CHI_TIET_NHIEM_VU_KHAC_PATH,
    exact: true,
    component: BaoCaoChiTietNhiemVuKhac,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.BAOCAO_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN_PATH,
    exact: true,
    component: BaoCaoChiTietNhiemVuKhacThanhVien,
    controller: 'BaoCao',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
  return routes.map(r => ({
    ...r,
    label: r.label || r.controller,
  }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
  {
    title: "Trang chủ",
    icon: "fas fa-home",
    isSingle: true,
    children: appRoutes.filter(r => r.menu && ["Home"].includes(r.controller)),
  },
  {
    title: "Báo cáo",
    icon: "fas fa-table",
    // Lấy tất cả route menu thuộc nhóm Báo cáo
    children: appRoutes.filter(r =>
      r.menu && [
        "LoginHistory",
        "StatisticLoginHistory",
      ].includes(r.controller)
    )
    },
    {
        title: "Phát triển phần mềm",
        icon: "fas fa-project-diagram",
        isSingle: true,
        children: appRoutes.filter(r =>
            r.menu && [
                "Project",
            ].includes(r.controller)
        ),
    },
    {
        title: "Xử lý yêu cầu",
        icon: "fas fa-ticket-alt",   // icon tùy chọn
        isSingle: true,
        children: appRoutes.filter(r =>
            r.menu && [
                "YeuCaus",
            ].includes(r.controller)
        )
    },
    {
        title: "Hỗ trợ phần mềm",
        icon: "fas fa-life-ring",   // icon tùy chọn
        isSingle: true,
        children: appRoutes.filter(r =>
            r.menu && [
                "HoTro",
            ].includes(r.controller)
        )
    },
    {
        title: "Nhiệm vụ khác",
        icon: "fas fa-check-circle",   // icon tùy chọn
        isSingle: true,
        children: appRoutes.filter(r =>
            r.menu && [
                "NhiemVuKhac",
            ].includes(r.controller)
        )
    },
        {
        title: "Nhiệm vụ cá nhân",
        icon: "fas fa-user-check",
        isSingle: true,
        children: appRoutes.filter(r =>
            r.menu && [
                "NhiemVuCaNhan",
            ].includes(r.controller)
        )
    },
    {
      title: "Báo cáo",
      icon: "fas fa-chart-bar",
      children: appRoutes.filter(
        (r) =>
          r.menu &&
          [
            URI_INTERNAL.BAOCAO_THONGKE_PATH,
            URI_INTERNAL.BAOCAO_THONG_HOP_NHAN_VIEN_PATH,
          ].includes(r.path)
      ),
    },

  {
    title: "Danh mục",
    icon: "fas fa-list",
    children: appRoutes.filter(r =>
      r.menu && [
        "BoPhan",
        "Team",
        "NhanVien",
        "QuyTrinh",
        "Khoa",
        "LinhVuc",
        "LoaiYeuCau",
        "NguoiPhoiHop",
      ].includes(r.controller)
    ),
  },
 {
    title: "Hệ thống",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "Account",
        "Role",
        "EmailConfig",
        "ApiRoleMapping",
        "OpeniddictApplication",
        "Log",
      ].includes(r.controller)
    ),
  },
];
